import { SupplierBookingWebService } from '@linktivity/gds-neo';
import { createServiceConfig } from '../config';

const config = createServiceConfig({
  Configuration: SupplierBookingWebService.Configuration
});

export default config;
